




















import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import RemoveFromCartTrigger from './RemoveFromCartTrigger.coffee'

export default
  name: 'RemoveFromCartTriggerModal'
  props: ['resourceComponent', 'resourceKey']
  components: { Modal, RequestButton }
  mixins: [RemoveFromCartTrigger.trigger(RemoveFromCartTrigger)]

  computed:
    lineItem: -> @modal?.config?.lineItem || {}
    event: -> @lineItem?.event || {}

